// Pages « bz- » : ingrédients filtrables, page FAQ (recherche, rubriques, « Voir tout »), suivi de commande.
(() => {
  // Ingrédients : onglets par saveur et bouton « Voir plus »
  function initIngredients(root) {
    const tabs = [...root.querySelectorAll('[data-bz-ingr-tab]')];
    const cards = [...root.querySelectorAll('[data-bz-ingr-keys]')];
    const more = root.querySelector('[data-bz-ingr-more]');
    const limit = parseInt(root.dataset.limit, 10) || 12;
    let key = 'all';
    let expanded = false;

    const render = () => {
      const match = cards.filter((c) => key === 'all' || c.dataset.bzIngrKeys.split(' ').includes(key));
      cards.forEach((c) => { c.hidden = true; });
      match.forEach((c, i) => { c.hidden = !expanded && i >= limit; });
      if (more) more.hidden = expanded || match.length <= limit;
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      key = tab.dataset.bzIngrTab;
      expanded = false;
      tabs.forEach((t) => { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', String(t === tab)); });
      render();
    }));
    more?.addEventListener('click', () => { expanded = true; render(); });
    render();
  }

  // Page FAQ : rubriques limitées, recherche, lien actif au défilement
  function initFaqPage(root) {
    const limit = parseInt(root.dataset.limit, 10) || 4;
    const cats = [...root.querySelectorAll('[data-bz-faqp-cat]')];
    const links = [...root.querySelectorAll('[data-bz-faqp-link]')];
    const search = root.querySelector('[data-bz-faqp-search]');
    const empty = root.querySelector('[data-bz-faqp-empty]');
    const open = new Set();
    const norm = (v) => v.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

    const render = () => {
      const q = norm(search?.value.trim() || '');
      let shown = 0;
      cats.forEach((cat) => {
        const items = [...cat.querySelectorAll('[data-bz-faqp-item]')];
        const all = cat.querySelector('[data-bz-faqp-all]');
        const match = items.filter((it) => !q || norm(it.textContent).includes(q));
        items.forEach((it) => { it.hidden = true; });
        const full = q || open.has(cat.dataset.bzFaqpCat);
        match.forEach((it, i) => { it.hidden = !full && i >= limit; });
        if (all) all.hidden = full || match.length <= limit;
        cat.hidden = match.length === 0;
        shown += match.length;
      });
      links.forEach((l) => {
        const cat = cats.find((c) => c.dataset.bzFaqpCat === l.dataset.bzFaqpLink);
        l.hidden = !!cat?.hidden;
      });
      if (empty) empty.hidden = shown > 0;
    };

    cats.forEach((cat) => cat.querySelector('[data-bz-faqp-all]')?.addEventListener('click', () => {
      open.add(cat.dataset.bzFaqpCat);
      render();
    }));
    search?.addEventListener('input', render);

    const setActive = (id) => links.forEach((l) => l.classList.toggle('is-on', l.dataset.bzFaqpLink === id));
    links.forEach((l) => l.addEventListener('click', () => setActive(l.dataset.bzFaqpLink)));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        const top = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (top) setActive(top.target.dataset.bzFaqpCat);
      }, { rootMargin: '-20% 0px -60% 0px' });
      cats.forEach((c) => io.observe(c));
    }
    render();
  }

  // Suivi de commande : adresse avec {order} et {email}, sinon le compte client
  function initTracking(form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const order = form.elements.order.value.trim().replace(/^#/, '');
      const email = form.elements.email.value.trim();
      const url = (form.dataset.url || '/account')
        .replace('{order}', encodeURIComponent(order))
        .replace('{email}', encodeURIComponent(email));
      window.location.href = url;
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-bz-ingr]').forEach(initIngredients);
    scope.querySelectorAll('[data-bz-faqp]').forEach(initFaqPage);
    scope.querySelectorAll('form[data-bz-tracking]').forEach(initTracking);
  }

  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
